import { Trans } from "@lingui/macro";
import { UiBox, UiPageFailure, UiTypography } from "@smp/ui";
import { useMemo } from "react";

import { SocialLinks } from "@/components/ui/social_links";

import { IProps } from "./page_failure.types";

const socialPagesWhiteList = ["vk", "facebook"] as const;

export const PageFailure = ({
  displaySocialLinks = true,
  errorCode,
  errorMessage,
  proposalMessage,
  title,
}: IProps) =>
  useMemo(
    () => (
      <UiPageFailure
        errorCode={errorCode}
        errorMessage={errorMessage}
        footer={
          displaySocialLinks ? (
            <UiBox>
              <UiTypography>
                <Trans>
                  Contact us on social media if the problem persists
                </Trans>
              </UiTypography>
              <UiBox display="flex" mt={1}>
                <SocialLinks
                  whiteList={socialPagesWhiteList}
                  BoxChildProps={{ mr: 2 }}
                />
              </UiBox>
            </UiBox>
          ) : undefined
        }
        proposalMessage={proposalMessage}
        title={title || <Trans>Unknown error.</Trans>}
      />
    ),
    [displaySocialLinks, errorCode, errorMessage, proposalMessage, title],
  );
